export const formatReadableDate = (
  isoString,
  options = { includeTime: false, locale: "en-IN" }
) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const dateOptions = {
    day: "2-digit",
    month: "long",
    year: "numeric",
    ...(options.includeTime && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };

  return date.toLocaleString(options.locale, dateOptions);
};
